export default function isEmptyString(value) {
    return !value.replace(/\s/g, '').length;
}